module.exports = __webpack_public_path__ + "./static/img/update_big.5ba077c695440acb141fc9e63f17a12c.png";


//////////////////
// WEBPACK FOOTER
// ./client/src/assets/fontawesome/update_big.png
// module id = ./client/src/assets/fontawesome/update_big.png
// module chunks = 0